module.exports = __webpack_public_path__ + "img/point.abe5fed8.png";